<template>
  <div
    v-click-outside="handleClickOutSize"
    :class="['container-inputselector']">
    <input
      v-model="input"
      :placeholder="placeholder"
      :class="['form-control', { 'is-invalid': isValid === false }]"
      :disabled="disabled || loading"
      @keydown="onKeydown"
      @click="handleClickInput"
    >
    <div
      v-if="option.show"
      class="options">
      <ul>
        <li
          v-for="(item, index) in filterOptions"
          :key="index"
          :class="[{ hover: option.hoverIndex === index }, { disabled: item.disabled } ]"
          @mousedown="onSelectItem(item)"
          @mouseover="onMouseOver(index)"
          @mouseleave="onMouseLeave"
        >
          {{ item.text }}
        </li>
        <li
          v-if="!isMatched && !isEmpty && createAble"
          class="add-item"
          @mousedown="onAddItem"
        >
          <span class="text-success">
            <i class="fas fa-plus"/>
            {{ $t('button.add') }}
          </span>
          {{ input }}
        </li>
        <li
          v-else-if="!filterOptions.length"
          class="not-found-item"
        >
          {{ $t('message.notfounddata') }}
        </li>
      </ul>
    </div>
    <div
      v-if="loading"
      class="loading">
      <i class="fas fa-spinner spin"/>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
  directives: {
    ClickOutside,
  },

  props: {
    value: [String, Number],
    options: {
      type: Array,
      default: () => ([]),
    },
    loading: Boolean,
    disabled: Boolean,
    createAble: {
      type: Boolean,
      default: true,
    },
  },

  data () {
    return {
      input: null,
      selectedValue: null,
      option: {
        hoverIndex: null,
        show: false,
      },
      isValid: null,
    }
  },

  computed: {
    placeholder () {
      if (this.createAble) {
        return this.$t('placeholder.selectorcreate')
      }
      return this.$t('placeholder.selectitem')
    },
    filterOptions () {
      if (!this.input) {
        return this.options
      }
      return this.options
        .filter((item) => {
          const input = this.input.toLowerCase()
          const text = item.text.toLowerCase()
          const match = text.match(input)
          return !!match
        })
    },
    isEmpty () {
      return !this.input
    },
    isMatched () {
      return this.filterOptions.length > 0
    },
  },

  watch: {
    input (newVal) {
      const { isEmpty, option } = this
      if (isEmpty) {
        this.$emit('remove', this.selectedValue)
        this.selectedValue = null
      } else {
        if (!option.show) {
          this.showOption()
        }
        this.isValid = true
      }
    },
    value () {
      this.init()
    },
    selectedValue (newVal) {
      this.$emit('input', newVal)
    },
  },

  created () {
    this.$emit('update:validateForm', this.validateForm)
    this.init()
  },

  methods: {
    onMouseOver (index) {
      this.option.hoverIndex = index
    },
    onMouseLeave () {
      this.option.hoverIndex = null
    },
    onSelectItem ({ text, value, disabled }) {
      if (!disabled) {
        this.selectedValue = value
        this.input = text
        this.$nextTick(() => {
          this.hideOption()
        })
      }
    },
    onAddItem () {
      this.hideOption()
      this.$emit('add', this.input)
    },
    onKeydown (e) {
      const { option: { show, hoverIndex }, filterOptions } = this
      if (e.key === 'Enter') {
        if (show && hoverIndex !== null) {
          const item = filterOptions[hoverIndex]
          this.onSelectItem(item)
        }
        return e.preventDefault()
      } else if (e.key === 'Backspace') {
        if (this.selectedValue) {
          this.input = null
        }
      } else if (e.key === 'ArrowDown' && show) {
        if (hoverIndex === null || hoverIndex >= (filterOptions.length - 1)) {
          this.option.hoverIndex = 0
        } else {
          this.option.hoverIndex++
        }
        const currentItem = filterOptions[this.option.hoverIndex]
        if (currentItem.disabled) {
          this.onKeydown({ key: 'ArrowDown' })
        }
        return e.preventDefault && e.preventDefault()
      } else if (e.key === 'ArrowUp' && show) {
        if (hoverIndex === null || hoverIndex <= 0) {
          this.option.hoverIndex = filterOptions.length - 1
        } else {
          this.option.hoverIndex--
        }
        const currentItem = filterOptions[this.option.hoverIndex]
        if (currentItem.disabled) {
          this.onKeydown({ key: 'ArrowUp' })
        }
        return e.preventDefault && e.preventDefault()
      }
    },
    handleClickInput () {
      this.showOption()
    },
    handleClickOutSize () {
      if (!this.selectedValue) {
        this.input = null
        this.selectedValue = null
      } else {
        this.input = this.options.find((item) => item.value == this.selectedValue).text
      }
      this.$nextTick(() => {
        this.hideOption()
      })
    },
    showOption () {
      this.option.show = true
    },
    hideOption () {
      this.option.show = false
    },
    validateForm () {
      if (this.selectedValue === null) {
        this.isValid = false
      } else {
        this.isValid = true
      }
    },
    init () {
      if (this.value) {
        const item = this.options.find((opt) => opt.value === this.value)
        if (item) {
          this.input = item.text
          this.selectedValue = this.value
          this.$nextTick(() => {
            this.hideOption()
          })
        }
      }
    },
  },
}
</script>

<style scoped>
.container-inputselector {
  position: relative;
}

.options {
  position: absolute;
  left: 0;
  bottom: -6px;
  transform: translateY(100%);
  width: 100%;
  border-radius: .25rem;
  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  z-index: 1;
}

ul {
  padding: 6px 0 6px 0;
  margin: 0;
}

li {
  padding: .375rem .75rem;
  cursor: pointer;
}

li.hover, li.add-item:hover {
  background-color: #f8f9fa;
}

li.disabled {
  opacity: .4;
  cursor: default;
}

li.not-found-item {
  cursor: default;
  color: #ccc;
}

.loading {
  position: absolute;
  display: flex;
  align-items: center;
  top: 0;
  right: 0;
  height: 100%;
  padding: 0 10px 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseInputSelector.vue